import { AuthenticatedUserModel } from '@/authentication/models';

export interface QueryParameters {
    clients: string[];
    campaigns: string[];
    eventId: string | undefined;
    state: string | undefined;
}

export interface AuthenticationState {
    authenticatedUser: AuthenticatedUserModel | undefined;
    sessionId: string | undefined;
    queryParameters: QueryParameters;
}

export const initialAuthenticationState: AuthenticationState = {
    authenticatedUser: undefined,
    sessionId: undefined,
    queryParameters: {
        clients: [],
        campaigns: [],
        eventId: undefined,
        state: undefined,
    },
};
